import React, { useState, useEffect } from "react";
import Widgets from "../../HomeCards/Card";
import CurrencyFormat from "react-currency-format";
import RequestHandler from "util/RequestHandler";
import moment from "moment";

const DbsNotPaidInvoiceTotalCurrentMonth = () => {
  const [widgetData, setWidgetData] = useState({
    loading: true,
  });

  useEffect(() => getData(), []);

  const getData = () => {
    RequestHandler.get("/DbsDashboard/NotPaidInvoiceTotalCurrentMonth").then((response) => {
      setWidgetData({
        data: response.data,
        loading: false,
      });
    });
  };

  return (
    <Widgets
      icon="calendar"
      currency={`${moment().format('DD')}-${moment().endOf('month').format('DD MMMM')}`}
      title="Fatura Toplamı"
      totalBalance={
        <CurrencyFormat
          value={widgetData.data}
          displayType={"text"}
          decimalSeparator={","}
          thousandSeparator={"."}
          prefix={"₺"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      }
    />
  );
};

export default DbsNotPaidInvoiceTotalCurrentMonth;
